// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file dev/moment/workspace/v1alpha1/registry.proto (package dev.moment.workspace.v1alpha1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Struct, Value } from "@bufbuild/protobuf";
import { TableSpec } from "../../differential/v1alpha1/store_pb";

/**
 * @generated from message dev.moment.workspace.v1alpha1.AttachedTable
 */
export class AttachedTable extends Message<AttachedTable> {
  /**
   * @generated from field: string table = 1;
   */
  table = "";

  /**
   * @generated from field: string primary_key = 2;
   */
  primaryKey = "";

  /**
   * @generated from field: repeated google.protobuf.Struct rows = 3;
   */
  rows: Struct[] = [];

  constructor(data?: PartialMessage<AttachedTable>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.AttachedTable";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "table", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "primary_key", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "rows", kind: "message", T: Struct, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AttachedTable {
    return new AttachedTable().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AttachedTable {
    return new AttachedTable().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AttachedTable {
    return new AttachedTable().fromJsonString(jsonString, options);
  }

  static equals(a: AttachedTable | PlainMessage<AttachedTable> | undefined, b: AttachedTable | PlainMessage<AttachedTable> | undefined): boolean {
    return proto3.util.equals(AttachedTable, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.CollabSessionInfo
 */
export class CollabSessionInfo extends Message<CollabSessionInfo> {
  /**
   * @generated from field: string branch = 1;
   */
  branch = "";

  /**
   * @generated from field: string sha = 2;
   */
  sha = "";

  /**
   * @generated from field: string status = 3;
   */
  status = "";

  constructor(data?: PartialMessage<CollabSessionInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.CollabSessionInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "sha", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CollabSessionInfo {
    return new CollabSessionInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CollabSessionInfo {
    return new CollabSessionInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CollabSessionInfo {
    return new CollabSessionInfo().fromJsonString(jsonString, options);
  }

  static equals(a: CollabSessionInfo | PlainMessage<CollabSessionInfo> | undefined, b: CollabSessionInfo | PlainMessage<CollabSessionInfo> | undefined): boolean {
    return proto3.util.equals(CollabSessionInfo, a, b);
  }
}

/**
 * the key is going to be the branch+sha,
 * as in the future, we might want to support multiple collab sessions with different branches
 *
 * @generated from message dev.moment.workspace.v1alpha1.DocumentCollabInfo
 */
export class DocumentCollabInfo extends Message<DocumentCollabInfo> {
  /**
   * @generated from field: map<string, dev.moment.workspace.v1alpha1.CollabSessionInfo> sessions = 1;
   */
  sessions: { [key: string]: CollabSessionInfo } = {};

  constructor(data?: PartialMessage<DocumentCollabInfo>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.DocumentCollabInfo";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "sessions", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: CollabSessionInfo} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentCollabInfo {
    return new DocumentCollabInfo().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentCollabInfo {
    return new DocumentCollabInfo().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentCollabInfo {
    return new DocumentCollabInfo().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentCollabInfo | PlainMessage<DocumentCollabInfo> | undefined, b: DocumentCollabInfo | PlainMessage<DocumentCollabInfo> | undefined): boolean {
    return proto3.util.equals(DocumentCollabInfo, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.DocumentCollabRegistry
 */
export class DocumentCollabRegistry extends Message<DocumentCollabRegistry> {
  /**
   * @generated from field: map<string, dev.moment.workspace.v1alpha1.DocumentCollabInfo> documents = 1;
   */
  documents: { [key: string]: DocumentCollabInfo } = {};

  constructor(data?: PartialMessage<DocumentCollabRegistry>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.DocumentCollabRegistry";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: DocumentCollabInfo} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DocumentCollabRegistry {
    return new DocumentCollabRegistry().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DocumentCollabRegistry {
    return new DocumentCollabRegistry().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DocumentCollabRegistry {
    return new DocumentCollabRegistry().fromJsonString(jsonString, options);
  }

  static equals(a: DocumentCollabRegistry | PlainMessage<DocumentCollabRegistry> | undefined, b: DocumentCollabRegistry | PlainMessage<DocumentCollabRegistry> | undefined): boolean {
    return proto3.util.equals(DocumentCollabRegistry, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.EnsureRegistryCreatedRequest
 */
export class EnsureRegistryCreatedRequest extends Message<EnsureRegistryCreatedRequest> {
  constructor(data?: PartialMessage<EnsureRegistryCreatedRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.EnsureRegistryCreatedRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureRegistryCreatedRequest {
    return new EnsureRegistryCreatedRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureRegistryCreatedRequest {
    return new EnsureRegistryCreatedRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureRegistryCreatedRequest {
    return new EnsureRegistryCreatedRequest().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureRegistryCreatedRequest | PlainMessage<EnsureRegistryCreatedRequest> | undefined, b: EnsureRegistryCreatedRequest | PlainMessage<EnsureRegistryCreatedRequest> | undefined): boolean {
    return proto3.util.equals(EnsureRegistryCreatedRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.EnsureRegistryCreatedResponse
 */
export class EnsureRegistryCreatedResponse extends Message<EnsureRegistryCreatedResponse> {
  constructor(data?: PartialMessage<EnsureRegistryCreatedResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.EnsureRegistryCreatedResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): EnsureRegistryCreatedResponse {
    return new EnsureRegistryCreatedResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): EnsureRegistryCreatedResponse {
    return new EnsureRegistryCreatedResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): EnsureRegistryCreatedResponse {
    return new EnsureRegistryCreatedResponse().fromJsonString(jsonString, options);
  }

  static equals(a: EnsureRegistryCreatedResponse | PlainMessage<EnsureRegistryCreatedResponse> | undefined, b: EnsureRegistryCreatedResponse | PlainMessage<EnsureRegistryCreatedResponse> | undefined): boolean {
    return proto3.util.equals(EnsureRegistryCreatedResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.CreateNewPageRequest
 */
export class CreateNewPageRequest extends Message<CreateNewPageRequest> {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId = "";

  /**
   * @generated from field: string branch = 2;
   */
  branch = "";

  /**
   * @generated from field: string sha = 3;
   */
  sha = "";

  /**
   * @generated from field: uint32 page_index = 4;
   */
  pageIndex = 0;

  /**
   * @generated from field: google.protobuf.Value page_metadata_json = 5;
   */
  pageMetadataJson?: Value;

  /**
   * @generated from field: google.protobuf.Struct page_prosemirror_json = 6;
   */
  pageProsemirrorJson?: Struct;

  /**
   * @generated from field: google.protobuf.Value request_page_json = 7;
   */
  requestPageJson?: Value;

  constructor(data?: PartialMessage<CreateNewPageRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.CreateNewPageRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sha", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "page_index", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 5, name: "page_metadata_json", kind: "message", T: Value },
    { no: 6, name: "page_prosemirror_json", kind: "message", T: Struct },
    { no: 7, name: "request_page_json", kind: "message", T: Value },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNewPageRequest {
    return new CreateNewPageRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNewPageRequest {
    return new CreateNewPageRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNewPageRequest {
    return new CreateNewPageRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNewPageRequest | PlainMessage<CreateNewPageRequest> | undefined, b: CreateNewPageRequest | PlainMessage<CreateNewPageRequest> | undefined): boolean {
    return proto3.util.equals(CreateNewPageRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.CreateNewPageResponse
 */
export class CreateNewPageResponse extends Message<CreateNewPageResponse> {
  constructor(data?: PartialMessage<CreateNewPageResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.CreateNewPageResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateNewPageResponse {
    return new CreateNewPageResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateNewPageResponse {
    return new CreateNewPageResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateNewPageResponse {
    return new CreateNewPageResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateNewPageResponse | PlainMessage<CreateNewPageResponse> | undefined, b: CreateNewPageResponse | PlainMessage<CreateNewPageResponse> | undefined): boolean {
    return proto3.util.equals(CreateNewPageResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.InitializeCollabStatesRequest
 */
export class InitializeCollabStatesRequest extends Message<InitializeCollabStatesRequest> {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId = "";

  /**
   * @generated from field: string branch = 2;
   */
  branch = "";

  /**
   * @generated from field: string sha = 3;
   */
  sha = "";

  /**
   * @generated from field: google.protobuf.Value metadata_json = 4;
   */
  metadataJson?: Value;

  /**
   * @generated from field: map<string, google.protobuf.Struct> pages_prosemirror_json = 5;
   */
  pagesProsemirrorJson: { [key: string]: Struct } = {};

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha1.TableSpec> base_tables = 6;
   */
  baseTables: { [key: string]: TableSpec } = {};

  /**
   * @generated from field: map<string, google.protobuf.Value> request_pages_data = 7;
   */
  requestPagesData: { [key: string]: Value } = {};

  /**
   * @generated from field: repeated dev.moment.workspace.v1alpha1.AttachedTable attached_tables = 8;
   */
  attachedTables: AttachedTable[] = [];

  constructor(data?: PartialMessage<InitializeCollabStatesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.InitializeCollabStatesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sha", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metadata_json", kind: "message", T: Value },
    { no: 5, name: "pages_prosemirror_json", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Struct} },
    { no: 6, name: "base_tables", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TableSpec} },
    { no: 7, name: "request_pages_data", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Value} },
    { no: 8, name: "attached_tables", kind: "message", T: AttachedTable, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitializeCollabStatesRequest {
    return new InitializeCollabStatesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitializeCollabStatesRequest {
    return new InitializeCollabStatesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitializeCollabStatesRequest {
    return new InitializeCollabStatesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InitializeCollabStatesRequest | PlainMessage<InitializeCollabStatesRequest> | undefined, b: InitializeCollabStatesRequest | PlainMessage<InitializeCollabStatesRequest> | undefined): boolean {
    return proto3.util.equals(InitializeCollabStatesRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.InitializeCollabStatesResponse
 */
export class InitializeCollabStatesResponse extends Message<InitializeCollabStatesResponse> {
  constructor(data?: PartialMessage<InitializeCollabStatesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.InitializeCollabStatesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitializeCollabStatesResponse {
    return new InitializeCollabStatesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitializeCollabStatesResponse {
    return new InitializeCollabStatesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitializeCollabStatesResponse {
    return new InitializeCollabStatesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InitializeCollabStatesResponse | PlainMessage<InitializeCollabStatesResponse> | undefined, b: InitializeCollabStatesResponse | PlainMessage<InitializeCollabStatesResponse> | undefined): boolean {
    return proto3.util.equals(InitializeCollabStatesResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.InitializeDocumentRequest
 */
export class InitializeDocumentRequest extends Message<InitializeDocumentRequest> {
  /**
   * @generated from field: string document_id = 1;
   */
  documentId = "";

  /**
   * @generated from field: string branch = 2;
   */
  branch = "";

  /**
   * @generated from field: string sha = 3;
   */
  sha = "";

  /**
   * @generated from field: google.protobuf.Value metadata_json = 4;
   */
  metadataJson?: Value;

  /**
   * @generated from field: map<string, google.protobuf.Struct> pages_prosemirror_json = 5;
   */
  pagesProsemirrorJson: { [key: string]: Struct } = {};

  /**
   * @generated from field: map<string, dev.moment.differential.v1alpha1.TableSpec> base_tables = 6;
   */
  baseTables: { [key: string]: TableSpec } = {};

  /**
   * @generated from field: map<string, google.protobuf.Value> request_pages_data = 7;
   */
  requestPagesData: { [key: string]: Value } = {};

  /**
   * @generated from field: repeated dev.moment.workspace.v1alpha1.AttachedTable attached_tables = 8;
   */
  attachedTables: AttachedTable[] = [];

  constructor(data?: PartialMessage<InitializeDocumentRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.InitializeDocumentRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "document_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "branch", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "sha", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "metadata_json", kind: "message", T: Value },
    { no: 5, name: "pages_prosemirror_json", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Struct} },
    { no: 6, name: "base_tables", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: TableSpec} },
    { no: 7, name: "request_pages_data", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: Value} },
    { no: 8, name: "attached_tables", kind: "message", T: AttachedTable, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitializeDocumentRequest {
    return new InitializeDocumentRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitializeDocumentRequest {
    return new InitializeDocumentRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitializeDocumentRequest {
    return new InitializeDocumentRequest().fromJsonString(jsonString, options);
  }

  static equals(a: InitializeDocumentRequest | PlainMessage<InitializeDocumentRequest> | undefined, b: InitializeDocumentRequest | PlainMessage<InitializeDocumentRequest> | undefined): boolean {
    return proto3.util.equals(InitializeDocumentRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.InitializeDocumentResponse
 */
export class InitializeDocumentResponse extends Message<InitializeDocumentResponse> {
  constructor(data?: PartialMessage<InitializeDocumentResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.InitializeDocumentResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): InitializeDocumentResponse {
    return new InitializeDocumentResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): InitializeDocumentResponse {
    return new InitializeDocumentResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): InitializeDocumentResponse {
    return new InitializeDocumentResponse().fromJsonString(jsonString, options);
  }

  static equals(a: InitializeDocumentResponse | PlainMessage<InitializeDocumentResponse> | undefined, b: InitializeDocumentResponse | PlainMessage<InitializeDocumentResponse> | undefined): boolean {
    return proto3.util.equals(InitializeDocumentResponse, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.CollabSessionsRequest
 */
export class CollabSessionsRequest extends Message<CollabSessionsRequest> {
  constructor(data?: PartialMessage<CollabSessionsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.CollabSessionsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CollabSessionsRequest {
    return new CollabSessionsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CollabSessionsRequest {
    return new CollabSessionsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CollabSessionsRequest {
    return new CollabSessionsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CollabSessionsRequest | PlainMessage<CollabSessionsRequest> | undefined, b: CollabSessionsRequest | PlainMessage<CollabSessionsRequest> | undefined): boolean {
    return proto3.util.equals(CollabSessionsRequest, a, b);
  }
}

/**
 * @generated from message dev.moment.workspace.v1alpha1.CollabSessionsResponse
 */
export class CollabSessionsResponse extends Message<CollabSessionsResponse> {
  /**
   * @generated from field: map<string, dev.moment.workspace.v1alpha1.DocumentCollabInfo> documents = 1;
   */
  documents: { [key: string]: DocumentCollabInfo } = {};

  constructor(data?: PartialMessage<CollabSessionsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "dev.moment.workspace.v1alpha1.CollabSessionsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "documents", kind: "map", K: 9 /* ScalarType.STRING */, V: {kind: "message", T: DocumentCollabInfo} },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CollabSessionsResponse {
    return new CollabSessionsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CollabSessionsResponse {
    return new CollabSessionsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CollabSessionsResponse {
    return new CollabSessionsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CollabSessionsResponse | PlainMessage<CollabSessionsResponse> | undefined, b: CollabSessionsResponse | PlainMessage<CollabSessionsResponse> | undefined): boolean {
    return proto3.util.equals(CollabSessionsResponse, a, b);
  }
}

